import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { FMS_READ_SCOPE, fmsReadBasePath } from '#/api/fmsMgmt/fmsReadScope';
import { paymentRequestListQueryToApiParams } from './listQueryToApiParams';

/** GET `/fms/payment-requests`（`.read`）或 `/fms/payment-requests/self`（`.self`） */
export async function fetchPaymentRequestList(listQuery, { scope = FMS_READ_SCOPE.ALL } = {}) {
  const { data: raw } = await request.get(fmsReadBasePath('payment-requests', scope), {
    params: paymentRequestListQueryToApiParams(listQuery, {
      allowPayeeFilter: scope === FMS_READ_SCOPE.ALL,
    }),
  });
  return parseVer4ListResponse(raw);
}
